import PropTypes from "prop-types";

import { buttonRowCss } from "../Actions.style";
import CancelButton from "../CancelButton";
import DeleteButton from "../DeleteButton";
import EditButton from "../EditButton";
import SaveButton from "../SaveButton";
import ShareButton from "../ShareButton";

const AnnotationActionsPropTypes = {
  annotationId: PropTypes.number,
  handleCancel: PropTypes.func,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleShare: PropTypes.func,
  isActionPending: PropTypes.bool,
  isDraft: PropTypes.bool,
  isEditMode: PropTypes.bool,
  isShared: PropTypes.bool,
  isTeacher: PropTypes.bool,
  hasReplies: PropTypes.bool,
};

const AnnotationActions = ({
  annotationId,
  handleCancel,
  handleSubmit,
  handleDelete,
  handleEdit,
  handleShare,
  isActionPending,
  isDraft,
  isEditMode,
  isShared,
  isTeacher,
  hasReplies,
}) => {
  if (isDraft || isEditMode) {
    return (
      <div css={buttonRowCss}>
        <CancelButton annotationId={annotationId} handleCancel={handleCancel}>
          Cancel
        </CancelButton>
        <SaveButton
          annotationId={annotationId}
          buttonFlavor="solid"
          handleSave={handleSubmit}
          isActionPending={isActionPending}
        />
      </div>
    );
  }

  return (
    <div css={buttonRowCss}>
      <DeleteButton
        annotationId={annotationId}
        isActionPending={isActionPending}
        handleDelete={handleDelete}
      />
      <EditButton annotationId={annotationId} handleEdit={handleEdit} />
      {isTeacher &&
        (isShared && hasReplies ? null : (
          <ShareButton
            annotationId={annotationId}
            isActionPending={isActionPending}
            handleShare={handleShare}
            isShared={isShared}
            hasReplies={hasReplies}
          />
        ))}
    </div>
  );
};

AnnotationActions.propTypes = AnnotationActionsPropTypes;

export default AnnotationActions;
